import jwtDecode from 'jwt-decode';
import { getActiveToken } from 'utils/tabAuth';
import { encodeChatParam } from 'utils/chatUrlEncoder';

export function getBusinessIdFromToken(): number | string {
  const token = getActiveToken();
  if (!token) {
    return '';
  }
  try {
    const decodedToken = jwtDecode(token) as { business?: { id?: number } };
    return decodedToken?.business?.id || '';
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return '';
  }
}

/**
 * Build the `?chat=` value for a chat link, stamping in the tab's current
 * business so the link is self-describing: opened in another business/tab it
 * routes to the right business instead of relying on a server-side lookup.
 */
export function encodeChatParamForCurrentBusiness(
  clientWaNumber: string,
): string {
  const businessId = Number(getBusinessIdFromToken()) || undefined;
  return encodeChatParam(clientWaNumber, businessId);
}
